(function ($, window, document, undefined) {

Filters = ( function() {

	function Constructor() {
		var timer;

		// Open portfolio modals
		function portfolioModalsTrigger() {
			$( '.portfolio-block .block-title, .portfolio-block .block-inner' ).click( function() {
				if( !$( '.deletion-check' ).hasClass( 'checking' ) ) {
					var index = $( this ).parents( '.portfolio-block' ).data( 'modal' );
					$( '.modal-' + index ).addClass( 'active' );
					$( 'body' ).addClass( 'noscroll' );

					var slug = $( this ).parents( '.portfolio-block' ).data( 'slug' );
					var name = $( this ).parents( '.portfolio-block' ).data( 'name' );
					var url = window.location;
					var nextURL = url + slug;
					var nextTitle = 'Portfolio - Arrington Capital | ' + name;
					var nextState = { additionalInformation: 'Updated the URL with JS' };
					window.history.pushState( nextState, nextTitle, nextURL );

				}
			} );

			$( '.modal .overlay' ).click( function() {
				$( '.modal' ).removeClass( 'active' );
				$( 'body' ).removeClass( 'noscroll' );
			} );

			$( '.modal .close' ).click( function() {
				$( '.modal' ).removeClass( 'active' );
				$( 'body' ).removeClass( 'noscroll' );
			} );
		}

		// Blog archive click events
		function blogClickEvents() {
			$( '.posts-block .featured-image, .posts-block .title' ).on( 'click', function() {
				$( this ).parents( '.posts-block' ).find( '.link' )[0].click();
			} );

			$( '.posts-block .post-tag' ).click( function () {
				var id = $( this ).data( 'id' );
				$( '.filter-list ul li[data-id=' + id + ']' ).click();
			} );

			$( '.posts-block .author-meta' ).click( function() {
				var authorId = $( this ).attr( 'data-author' );
				$( '.search-block .search input' ).val( '' );
				$( '.filter-title' ).removeClass( 'selected' );
				var termID = $( '.filter-title.selected' ).data( 'cat' );
				searchCallBlog( '', termID, authorId );
			} );

			$( '.back-to-posts' ).click( function() {
				searchCallBlog( '' );
			} );

			$( '.reset-query' ).click( function() {
				$( '.search-block .search input' ).val( '' );

				$( '.filter-title' ).removeClass( 'selected' );
				searchCallBlog( '' );
			} );
		}

		// Jobs Block click
		function jobsClickEvents() {
			$( '.jobs-block .block-inner' ).click( function() {
				if( !$( '.deletion-check' ).hasClass( 'checking' ) ) {
					$( this ).find( '.listing-link' )[0].click();
				}
			} );
		}

		// Blog archive pagination
		function blogPagination() {
			var linkCount = $( '.pagination .pages-holder div' ).length;
			$( '.pagination .pages-holder div').click( function() {
				var cluster = $( this ).data( 'index' );
				$( '.posts-blocks' ).addClass( 'hidden' );

				window.scroll({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});

				$( '.pagination .pages-holder div' ).removeClass( 'current' );
				$( this ).addClass( 'current' );

				if( cluster > 1 ) {
					$( '.pagination .prev').removeClass( 'disabled' );
				} else {
					$( '.pagination .prev').addClass( 'disabled' );
				}

				if( linkCount == cluster ) {
					$( '.pagination .next').addClass( 'disabled' );
				} else {
					$( '.pagination .next').removeClass( 'disabled' );
				}

				setTimeout( function() {
					$( '.posts-cluster' ).removeClass( 'current' );
					$( '.posts-cluster[data-cluster=' + cluster + ']').addClass( 'current' );
					$( '.posts-blocks' ).removeClass( 'hidden' );
				}, 300 );
			} );

			$( '.pagination .prev').click( function() {
				$( '.pagination .next').removeClass( 'disabled' );
				var cluster = $( '.pagination .pages-holder div.current' ).data( 'index' );

				if( cluster > 1 ) {
					$( '.posts-blocks' ).addClass( 'hidden' );

					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth'
					});

					$( '.pagination .pages-holder div.current' ).removeClass( 'current' );
					$( '.pagination .pages-holder div[data-index=' + (cluster - 1) + ']' ).addClass( 'current' );

					if( cluster == 2 ) {
						$( this ).addClass( 'disabled' );
					}

					setTimeout( function() {
						$( '.posts-cluster' ).removeClass( 'current' );
						$( '.posts-cluster[data-cluster=' + (cluster - 1) + ']').addClass( 'current' );
						$( '.posts-blocks' ).removeClass( 'hidden' );
					}, 300 );
				}
			} );

			$( '.pagination .next').click( function() {
				$( '.pagination .prev').removeClass( 'disabled' );
				var cluster = $( '.pagination .pages-holder div.current' ).data( 'index' );

				if( linkCount > cluster ) {
					$( '.posts-blocks' ).addClass( 'hidden' );

					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth'
					});

					$( '.pagination .pages-holder div.current' ).removeClass( 'current' );
					$( '.pagination .pages-holder div[data-index=' + (cluster + 1) + ']' ).addClass( 'current' );

					if( cluster == linkCount - 1 ) {
						$( this ).addClass( 'disabled' );
					}

					setTimeout( function() {
						$( '.posts-cluster' ).removeClass( 'current' );
						$( '.posts-cluster[data-cluster=' + (cluster + 1) + ']').addClass( 'current' );
						$( '.posts-blocks' ).removeClass( 'hidden' );
					}, 300 );
				}
			} );
		}

		// homogenize Blocks
		function blockSizing() {
			$( '.block' ).each( function() {
				var width = $( this ).innerWidth();
				$( this ).css( 'height', width );
			} );
		}

		// Edit Mode
		function resetEditMode() {
			$( '#edit-mode' ).click( function() {
				$( '.filtered-blocks' ).toggleClass( 'editing' );
			} );

			$( '.edit-options .delete-item' ).click( function() {
				$( this ).parents( '.filtered-block' ).find( '.deletion-check' ).addClass( 'checking' );
			} );

			$( '.deletion-check .delete-yes' ).click( function( e ) {
				e.stopPropagation();
				var block = $( this ).parents( '.filtered-block' );
				var check = $( this ).parents( '.deletion-check' );
				var id = block.data( 'id' );

				$.ajax( {
					method: 'GET',
					url: '/wp-admin/admin-ajax.php',
					data: {
						action: 'delete_item',
						id: id
					},
					success: function( response ) {
						check.html( response );
						setTimeout( function() {
							block.hide();
							block.remove();
						}, 2000 );
					}
				} );
			} );

			$( '.deletion-check .delete-no' ).click( function( e ) {
				e.stopPropagation();
				$( this ).parents( '.deletion-check' ).removeClass( 'checking' );
			} );
		}

		function filterSuccess( response = '' ) {
			if( $( '.filtered-blocks' ).length > 0 ) {
				$( '.filtered-blocks' ).replaceWith( response );
				blockSizing();
				resetEditMode();

				if( $( '#portfolio' ).length > 0 ) {
					portfolioModalsTrigger();
				}

				if( $( '#blog-archive' ).length > 0 ) {
					blogClickEvents();
					blogPagination();
				}

				if( $( '#careers' ).length > 0 ) {
					jobsClickEvents();
				}
				setTimeout( function() {
					$( '.filtered-blocks' ).removeClass( 'hidden' );
					$( '.no-results' ).removeClass( 'hidden' );
				}, 200 );
			} else {
				$( '.no-results' ).replaceWith( response );
				blockSizing();
				resetEditMode();

				if( $( '#portfolio' ).length > 0 ) {
					portfolioModalsTrigger();
				}

				if( $( '#blog-archive' ).length > 0 ) {
					blogClickEvents();
					blogPagination();
				}

				if( $( '#careers' ).length > 0 ) {
					jobsClickEvents();
				}
				setTimeout( function() {
					$( '.filtered-blocks' ).removeClass( 'hidden' );
					$( '.no-results' ).removeClass( 'hidden' );
				}, 200 );
			}

		}

		function searchCall( search ) {
			var termIds = [];
			var filterAction;

			var homeCheck = 'filtered';

			$( '.active-tags span' ).each( function() {
				if( $( this ).data( 'id' ) ) {
					termIds.push( $( this ).data( 'id' ) );
				}
			} );

			var sort = $( '.sort-list ul li.selected' ).data( 'sort' );

			var postType = $( '.filters' ).data( 'cpt' );

			if( postType == 'post' ) {
				filterAction = 'blog_filters';
			} else if( postType == 'jobs' ) {
				filterAction = 'careers_filters';
			} else if( postType == 'portfolio' ) {
				filterAction = 'portfolio_filters';
				$( '.portfolio-modals' ).remove();
			}

			$( '.filter-list' ).removeClass( 'opened' );

			if( $( '.filtered-blocks' ).length > 0 ) {
				$( '.filtered-blocks' ).animate( { opacity: 0 }, 300, function() {
					$.ajax( {
						method: 'GET',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: filterAction,
							term_ids: termIds,
							search: search,
							home_check: homeCheck,
							sort: sort
						},
						success: function( response ) {
							filterSuccess( response );
						}
					} );
				});
			} else {
				$( '.no-results' ).animate( { opacity: 0 }, 300, function() {
					$.ajax( {
						method: 'GET',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: filterAction,
							term_ids: termIds,
							search: search,
							home_check: homeCheck,
							sort: sort
						},
						success: function( response ) {
							filterSuccess( response );
						}
					} );
				});
			}
		}

		function searchCallBlog( search, termId, author = false ) {
			var homeCheck = 'filtered';

			if ( author ) {
				var authorId = author;
			}

			if( $( '.filtered-blocks' ).length > 0 ) {
				$( '.filtered-blocks' ).animate( { opacity: 0 }, 300, function() {
					$.ajax( {
						method: 'GET',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: 'blog_filters',
							term_ids: termId,
							search: search,
							home_check: homeCheck,
							author_query_id: authorId
						},
						success: function( response ) {
							filterSuccess( response );
						}
					} );
				});
			} else {
				$( '.no-results' ).animate( { opacity: 0 }, 300, function() {
					$.ajax( {
						method: 'GET',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: 'blog_filters',
							term_ids: termId,
							search: search,
							home_check: homeCheck
						},
						success: function( response ) {
							filterSuccess( response );
						}
					} );
				});
			}
		}

		this.careers = function ( postIds ) {
			if( $( postIds ).length > 0 ) {
				$( '.filtered-blocks' ).animate( { opacity: 0 }, 300, function() {
					$.ajax( {
						method: 'GET',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: 'careers_filters',
							post_ids: postIds
						},
						success: function( response ) {
							filterSuccess( response );
						}
					} );
				});
			}
		};

		this.start = function ( ) {
			if( $( '#portfolio' ).length > 0 ) {
				portfolioModalsTrigger();
			}

			if( $( '#blog-archive' ).length > 0 ) {
				blogClickEvents();
				blogPagination();
			}

			if( $( '#careers' ).length > 0 ) {
				jobsClickEvents();
			}

			resetEditMode();

			if( $( '#blog-archive' ).length > 0 || $( '#careers' ).length > 0 ) {
				$( '.search-block .search input' ).keyup( function ( e ) {
					e.preventDefault();
					var search = $( this ).val();

					if ( timer ) {
						clearTimeout( timer );
						timer = null;
					}
					timer = setTimeout( function () {
						if( $( '#blog-archive' ).length > 0 ) {
							var termID = $( '.filter-title.selected' ).data( 'cat' );
							searchCallBlog( search, termID );
						} else {
							searchCall( search );
						}
					}, 300 );
				} );
			}

			if( $( '#portfolio' ).length > 0 || $( '#careers' ).length > 0 ) {
				$( '.filter-list ul li' ).click( function() {
					if ( $( this ).parents( '.filter-list' ).hasClass( 'sort-list' ) ) {
						$( '.sort-list ul li' ).removeClass( 'selected' );
					}
					var search = $( '.search-block .search input' ).val();
					var id = $( this ).data( 'id' );
					var tag = $( this ).text();

					var list = $( this ).parents( '.filter-list' );
					var filterBlock = $( this ).parents( '.filter-block' );

					if( !$( this ).hasClass( 'selected' ) ) {
						filterBlock.find( '.active-tags' ).addClass( 'filled' );
						filterBlock.find( '.active-tags' ).append( '<span class="tag" data-id="' + id + '">' + tag + '</span>' );
						filterBlock.find( '.filter-title' ).removeClass( 'opened' );
						list.removeClass( 'opened' );
						$( this ).addClass( 'selected' );
					} else {
						filterBlock.find( '.active-tags span[data-id=' + id + ']' ).remove();
						$( this ).removeClass( 'selected' );

						if( filterBlock.find( '.active-tags .tag' ).length == 0 ) {
							filterBlock.find( '.active-tags' ).removeClass( 'filled' );
						}
					}

					filterBlock.find( '.active-tags .tag' ).click( function () {
						var thisTag = $( this );
						var id = $( this ).data( 'id' );

						list.find( 'ul li' ).each( function() {
							if( $( this ).data( 'id' ) == id ) {
								$( this ).removeClass( 'selected' );
							}
						} );

						$( this ).addClass( 'hide' );
						$( this ).removeAttr( 'data-id' ).removeData( 'id' );
						setTimeout( function() {
							thisTag.remove();
							if( filterBlock.find( '.active-tags .tag' ).length == 0 ) {
								filterBlock.find( '.active-tags' ).removeClass( 'filled' );
							}
						}, 400 );

						var search = $( '.search-block .search input' ).val();

						searchCall( search );

					} );

					searchCall( search );

				} );
			}

			$( '.filter-title' ).click( function() {
				if( $( '#blog-archive' ).length > 0 ) {
					var search = $( '.search-block .search input' ).val();

					if( $( this ).hasClass( 'selected' ) ) {
						$( this ).removeClass( 'selected' );
						searchCallBlog( search );
					} else {
						$( this ).addClass( 'selected' );
						var termID = $( '.filter-title.selected' ).data( 'cat' );
						searchCallBlog( search, termID );
					}

				} else {
					$( '.filter-title' ).not( $( this ) ).removeClass( 'opened' );
					$( '.filter-title' ).not( $( this ) ).siblings( '.filter-list' ).removeClass( 'opened' );
					$( this ).toggleClass( 'opened' );
					$( this ).siblings( '.filter-list' ).toggleClass( 'opened' );
				}
			});

		};

	}
	return new Constructor();

}() );

})(jQuery, window, document);
